module.exports = __webpack_public_path__ + "static/media/rcsi.03b54d23.jpg";